export const phoneValidator = (phone) => /\+7\s\(7\d{2}\)\s\d{3}\-\d{2}\-\d{2}/
    .test(phone);

export const emailValidator = (email) => /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
    .test(email);